import { useCallback } from "react";
interface Props {
  data: any[];
  value: any;
}
/**
 * Custom hook to process and transform select data for dropdowns.
 *
 * @param props - An object containing the following properties:
 *   - data: An array of objects representing the select options.
 *   - value: The current selected value, which can be an object with `key` and `value` properties.
 * @returns A memoized function that transforms the select data based on the provided value.
 */
const useGetSelectData = ({ data, value }: Props) => {
  return useCallback(() => {
    if (typeof value === "object" && value?.key && value?.value) {
      const items: any[] = [];
      let i = 0;
      for (const item of data) {
        items.push({ ...item, chrisKey: item.value });
        if (item.value === value.key && item.label !== value.value) {
          items.push({
            value: item.value + i,
            label: value.value,
            chrisKey: item.value,
            ...(item?.isLabel && { isLabel: item.isLabel }),
          });
          i++;
        }
      }

      return items;
    }

    return data.map(item => ({ ...item, chrisKey: item.value }));
  }, [data, value]);
};
export default useGetSelectData;
